import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  blocks: {
    id: 'studio.+im1ZA',
    defaultMessage: 'Blocks',
  },
  documentation: {
    id: 'studio.isGKnz',
    defaultMessage: 'Documentation',
  },
  feedback: {
    id: 'studio.Ejhdi4',
    defaultMessage: 'Feedback',
  },
  logoutButton: {
    id: 'studio.C81/uG',
    defaultMessage: 'Logout',
  },
  login: {
    id: 'studio.AyGauy',
    defaultMessage: 'Login',
  },
  settings: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  pfp: {
    id: 'studio.O9GTIc',
    defaultMessage: 'Profile picture',
  },
});
